import React from 'react';
import PropTypes from 'prop-types';
import { Text, View } from 'react-native';
import { Interactable } from 'LocalGluons';

import Hr from 'LocalGluons/components/Hr';
import Icon from 'LocalGluons/components/Icon';
import { styles } from './Showtime.jss';

export const Showtime = ({ text, channelName, onPress, index }) => (
    <View style={styles.container}>
        <Interactable style={styles.textContainer} onPress={onPress}>
            <Text style={styles.text}>{text}</Text>
            <Text style={styles.channelName}>{channelName}</Text>
            <View style={styles.iconContainer}>
                <Icon style={styles.icon} name="arrow_right" testID={`more_${index}`} />
            </View>
        </Interactable>
        <Hr style={styles.itemDivider} />
    </View>
);

Showtime.defaultProps = {
    onPress: null,
    index: null
};

Showtime.propTypes = {
    text: PropTypes.string.isRequired,
    channelName: PropTypes.string.isRequired,
    onPress: PropTypes.func,
    index: PropTypes.number
};
